import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../auth/services/authentication.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  resetEmail: string;

  constructor(private authService: AuthenticationService) {}

  ngOnInit() {}

  handleResetPasswordBtnClick = (isEmailValid: string) => {
    if (this.resetEmail) {
      this.authService.sendPasswordResetEmail(this.resetEmail);
    }
  };
}
